import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ActionConfirmationDialogData {
    submitBtnText?: string;
    confirmMessage?: string;
    availabilityModal?: boolean;
}

@Component({
    selector: 'app-action-confirmation',
    templateUrl: './action-confirmation-dialog.component.html',
    styleUrls: ['./action-confirmation-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ActionConfirmationDialogComponent {
    readonly confirmMessage: string;
    readonly isAvailabilityModal: boolean;
    readonly submitBtnText: string;

    constructor(
        private readonly matDialogRef: MatDialogRef<ActionConfirmationDialogComponent, boolean | undefined>,
        @Inject(MAT_DIALOG_DATA) private readonly data: ActionConfirmationDialogData,
    ) {
        this.submitBtnText = this.data.submitBtnText ?? 'Ok';
        this.confirmMessage = this.data.confirmMessage ?? '';
        this.isAvailabilityModal = this.data.availabilityModal ?? false;
    }

    onConfirmation(isConfirm: boolean): void {
        this.matDialogRef.close(isConfirm ? true : undefined);
    }
}
